module.exports = __webpack_public_path__ + "static/media/9.5b562165.png";